enum CustomerAuthProvider {
  Bite = 'bite',
  Paytronix = 'paytronix',
}

export { CustomerAuthProvider };
